
























import {
  myVue
} from "@/components/class/myVue";
import {
  Component
} from 'vue-property-decorator';

@Component
export default class HelloWorld extends myVue {
  my_open() {
    this.current.open()
  }

  my_close() {
    this.current.close()
  }

  public_click2(data: any) {
    data.item.click()
  }
}
